export default __webpack_public_path__ + "static/media/nav-settings-fill.4fbfb8e1.svg";